// root '../../../';

// dependencies
import { Child } from 'pym.js';
import * as d3 from 'd3';
import Swiper from 'swiper';
import Zion from './utils/Zion';
import { classify } from './utils/helpers';

import data from './data/data.json';

// styles
import './styles/graphic.scss';

/* develblock:start */
import meta from './data/meta.json';

let swiper;
const pkg = require('../package.json');

if (process.env.NODE_ENV === 'development') {
  console.clear();
}

window.pymChild = new Child({ renderCallback: init, id: pkg.name });

window.onload = () => {
  if (process.env.NODE_ENV === 'development') {
    Object.keys(meta).forEach((id) => {
      const node = document.querySelector(`.${id}`);
      if (node) node.innerHTML = meta[id];
    });
  }

  const { pymChild } = window;
  pymChild.sendHeight();

  if (window.pymChild.parentUrl) {
    const zion = new Zion(pkg.name, pymChild.parentUrl.split('?')[0]);
  }
};

function formatDate(s) {
  if (!s) return '';
  const months = ['Jan.', 'Feb.', 'Mar.', 'Apr.', 'May', 'Jun.', 'Jul.', 'Aug.', 'Sep.', 'Oct.', 'Nov.', 'Dec.'];
  const num = Number(s);
  // Excel serial dates: days since Jan 1, 1900
  const d = (!isNaN(num) && num > 1000)
    ? new Date((num - 25569) * 86400000)
    : new Date(s);
  if (isNaN(d)) return String(s);
  const month = months[d.getUTCMonth()];
  const day = String(d.getUTCDate());
  return `${month} ${day}, ${d.getUTCFullYear()}`;
}

function sortDateDesc(rows) {
  const t = (s) => {
    if (!s) return 0;
    const ms = new Date(s).getTime();
    return Number.isNaN(ms) ? 0 : ms;
  };
  return [...rows].sort((a, b) => t(b.date) - t(a.date));
}


function populateSlider() {
  const rows = sortDateDesc(data);
  const swiperWrapper = d3.select('div.swiper-wrapper').html('');
  const slides = swiperWrapper.selectAll('.swiper-slide')
    .data(rows)
    .enter()
    .append('div')
    .attr('class', 'swiper-slide');

  const card = slides.append('div')
    .attr('class', d => (d.type === 'quote' ? 'card card--quote' : 'card'));

  card.each(function (d) {
    const el = d3.select(this);
    const isQuote = d.type === 'quote';

    const profile = el.append('div').attr('class', 'profile');
    const photoWrap = profile.append('div').attr('class', 'profile-photo-wrap');
    const imgOrDiv = document.createElement(d.photo ? 'img' : 'div');
    if (d.photo && imgOrDiv.tagName === 'IMG') imgOrDiv.src = d.photo;
    imgOrDiv.className = 'profile-photo';
    photoWrap.node().appendChild(imgOrDiv);

    const profileText = profile.append('div').attr('class', 'profile-text');
    profileText.append('p').attr('class', 'profile-name').text(d.name || '');

    const locationEl = profileText.append('p').attr('class', 'card-location');
    if (!isQuote && d.source) {
      locationEl.append('a').attr('href', d.source).attr('target', '_blank').text(d.location || '');
    } else {
      locationEl.text(d.location || '');
    }

    profileText.append('p').attr('class', 'card-date').text(formatDate(d.date));

    el.append('p').attr('class', 'blurb').html(d.post || '');
  });
}

function init() {
  populateSlider();

  swiper = new Swiper('.swiper', {
    direction: 'horizontal',
    cssMode: true,
    slidesPerView: 'auto',
    spaceBetween: 8,
    freeMode: {
      enabled: true,
    },
  });

  const swiperEl = document.querySelector('.swiper');
  const wrapperEl = document.querySelector('.swiper-wrapper');

  if (wrapperEl) {
    const checkScrollEnd = () => {
      const atEnd = wrapperEl.scrollLeft + wrapperEl.clientWidth >= wrapperEl.scrollWidth - 2;
      swiperEl.classList.toggle('at-end', atEnd);
    };
    // wrapperEl.addEventListener('scroll', checkScrollEnd);
    // window.addEventListener('resize', checkScrollEnd);
    // checkScrollEnd();
  }
}
